export const useNotificationUserSettings = () => null;
